import { Navigate, useParams } from 'react-router-dom';
export default function YouthPolicy() { const { lang = 'en' } = useParams(); return <Navigate to={`/${lang}/servicepolicy`} replace />; }
